import SpinRecord from "slotworks/model/gameplay/records/spin-record";

export default class MCSpinRecord extends SpinRecord {

    /** ID for debugging purposes */
    public id: string = "MCSpinRecord";

    public complete = false;

    public spinsRemaining: number;

    public numberOfChildren: number;
}
